import { useState, useEffect, useCallback } from "react";

export type AlertType = "success" | "error" | "info" | "warning";

interface AlertMessage {
  text: string;
  type: AlertType;
  autoClose?: boolean;
  duration?: number; // milliseconds
}

export const useAlertMessage = () => {
  const [message, setMessage] = useState<AlertMessage | null>(null);

  const showMessage = useCallback(
    (text: string, type: AlertType = "info", options?: { autoClose?: boolean; duration?: number }) => {
      setMessage({
        text,
        type,
        autoClose: options?.autoClose ?? true,
        duration: options?.duration ?? 7000,
      });
    },
    []
  );

  const clearMessage = useCallback(() => {
    setMessage(null);
  }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (message?.autoClose) {
      timer = setTimeout(() => {
        setMessage(null);
      }, message.duration);
    }

    return () => clearTimeout(timer);
  }, [message]);

  return {
    message,
    showMessage,
    clearMessage,
  };
};
